var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.138672 5.76953C0.138672 5.88672 0.160156 5.99805 0.203125 6.10352C0.25 6.20508 0.322266 6.30273 0.419922 6.39648L4.93164 10.8086C5.08008 10.957 5.26172 11.0312 5.47656 11.0312C5.625 11.0312 5.75781 10.9961 5.875 10.9258C5.99609 10.8555 6.0918 10.7617 6.16211 10.6445C6.23633 10.5273 6.27344 10.3945 6.27344 10.2461C6.27344 10.0312 6.19141 9.83984 6.02734 9.67188L2.01367 5.76953L6.02734 1.86719C6.19141 1.70312 6.27344 1.51172 6.27344 1.29297C6.27344 1.14844 6.23633 1.01758 6.16211 0.900391C6.0918 0.779297 5.99609 0.683594 5.875 0.613281C5.75781 0.542969 5.625 0.507812 5.47656 0.507812C5.26172 0.507812 5.08008 0.582031 4.93164 0.730469L0.419922 5.14258C0.326172 5.23633 0.255859 5.33398 0.208984 5.43555C0.166016 5.53711 0.142578 5.64844 0.138672 5.76953Z",
    fill: "#2A2E33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.42549f89b91bf3dfc1615ced82cc7cef.svg";
export { ForwardRef as ReactComponent };